// Ambassador referral attribution (first valid click within 30 days wins).
export const AMBASSADOR_ENABLED = process.env.REACT_APP_AMBASSADOR_TRACKING_ENABLED === "1";

const REF_KEY = "metier_amb_ref";
const VISITOR_KEY = "metier_visitor_id";
const WINDOW_MS = 30 * 24 * 3600 * 1000;

function safeGet(k) {
  try { return window.localStorage.getItem(k); } catch { return null; }
}
function safeSet(k, v) {
  try { window.localStorage.setItem(k, v); } catch { /* storage unavailable */ }
}

export function getVisitorId() {
  let v = safeGet(VISITOR_KEY);
  if (!v) {
    v = `v_${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`;
    safeSet(VISITOR_KEY, v);
  }
  return v;
}

export function getStoredRef() {
  try {
    const r = JSON.parse(safeGet(REF_KEY) || "null");
    if (r && r.code && Date.now() - r.at < WINDOW_MS) return r.code;
  } catch { /* corrupt value */ }
  return null;
}

// Keeps the first valid code; a later link never overrides an unexpired one.
export function storeRef(code) {
  if (!getStoredRef()) safeSet(REF_KEY, JSON.stringify({ code, at: Date.now() }));
}

export function attributionHeaders() {
  if (!AMBASSADOR_ENABLED) return {};
  const h = { "X-Metier-Visitor": getVisitorId() };
  const ref = getStoredRef();
  if (ref) h["X-Metier-Ref"] = ref;
  return h;
}
